<ng-container *ngFor="let artefakt of artefakteFiltered,trackBy: trackByFn">
  <lv-uiartefakt-renderer [uiArtefakt]="artefakt"></lv-uiartefakt-renderer>
</ng-container>
